import { render, staticRenderFns } from "./BannerDeAmbiente.vue?vue&type=template&id=77331dde&scoped=true&"
import script from "./BannerDeAmbiente.vue?vue&type=script&lang=ts&"
export * from "./BannerDeAmbiente.vue?vue&type=script&lang=ts&"
import style0 from "./BannerDeAmbiente.vue?vue&type=style&index=0&id=77331dde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77331dde",
  null
  
)

export default component.exports